import { mapState } from 'vuex';
import ApiService from '@/services/apiService';
import get from 'lodash/get';
const bulkData = {
  executions: {}
};
const bridgesThatDoNotReadFromExternalData = ['bridge-mqtt', 'bridge-incomingwebhook', 'bridge-webhook', 'bridge-wireless-mbus-decoder'];
export default {
  name: 'CoreVirtualDeviceBulkEdit',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    isCalculating: {
      type: Boolean,
      default: false
    },
    isCalculatingError: {
      type: Boolean,
      default: false
    },
    belongToSameAccount: {
      type: Boolean,
      default: false
    },
    devices: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      modes: {
        CHANGE_META_INFORMATION: 1,
        LINK_DEVICES_TO_A_TEMPLATE: 2,
        DELETE_ALL_SELECTED_DEVICES: 3
      },
      step: 1,
      stepForm: {
        selectMode: null,
        operationalStatus: null,
        title: '',
        parentId: null,
        groupsTags: [],
        groupsToRemove: [],
        tags: [],
        tagsToRemove: [],
        deviceTemplates: null,
        removeFromExternalSystem: false,
        numberOfVirtualDevices: ''
      },
      deviceTags: {
        tags: []
      },
      deviceTagsToRemove: {
        tags: []
      },
      deviceGroups: [],
      tenantId: null,
      deviceTemplatesData: {
        templates: [],
        currentPage: 1,
        hasMore: true,
        isLoading: false
      },
      hasDeviceThatReadFromExternalSystem: false
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'color']),
    isContinueBtnDisabled() {
      if (this.stepForm.selectMode === this.modes.CHANGE_META_INFORMATION) {
        return (
          // the combobox yields '' (not null) when typed free text is cleared
          (this.stepForm.operationalStatus === null || this.stepForm.operationalStatus === '') && this.stepForm.parentId === null && this.stepForm.groupsTags.length === 0 && this.stepForm.groupsToRemove.length === 0 && this.stepForm.tags.length === 0 && this.stepForm.tagsToRemove.length === 0
        );
      }
      if (this.stepForm.selectMode === this.modes.LINK_DEVICES_TO_A_TEMPLATE) {
        return this.stepForm.deviceTemplates === null;
      }
      if (this.stepForm.selectMode === this.modes.LINK_DEVICES_TO_A_TEMPLATE) {
        return this.stepForm.deviceTemplates === null;
      }
      if (this.stepForm.selectMode === this.modes.DELETE_ALL_SELECTED_DEVICES) {
        return false;
      }
      return true;
    },
    selectMode() {
      return [{
        text: this.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.selectMode.text1'),
        value: this.modes.CHANGE_META_INFORMATION
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.selectMode.text3'),
        value: this.modes.DELETE_ALL_SELECTED_DEVICES
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.selectMode.text2'),
        value: this.modes.LINK_DEVICES_TO_A_TEMPLATE
      }];
    },
    removeFromExternalSystem() {
      return [{
        text: this.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.removeFromRemoteSystem'),
        value: true
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.doNotRemoveFromRemoteSystem'),
        value: false
      }];
    },
    operationalStatusLabels() {
      return this.operationalStatus.reduce((acc, status) => {
        acc[status.value] = status.text;
        return acc;
      }, {});
    },
    operationalStatus() {
      return [{
        text: this.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.operationalStatus.unset'),
        value: 0
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.operationalStatus.inTransit'),
        value: 1
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.operationalStatus.readyForOperation'),
        value: 2
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.operationalStatus.inOperation'),
        value: 3
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.operationalStatus.temporaryInactive'),
        value: 4
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.operationalStatus.decommissioned'),
        value: 5
      }];
    },
    rules() {
      return [v => !!v || this.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.errors.required'), v => (v.trim() || '').length <= 50 || this.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.errors.max', {
        n: 50
      }), v => (v.trim() || '').length >= 5 || this.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.errors.min', {
        n: 5
      })];
    },
    getTotalDevicesNumber() {
      return this.devices.length;
    },
    applyBtnDisabled() {
      return this.stepForm.title === '' || this.stepForm.title.length < 5 || this.stepForm.title.length > 50 || !this.numberOfDevicesMatch();
    },
    hasMultipleTenants() {
      return !this.belongToSameAccount;
    },
    linkSelectionToTemplateCheck() {
      const result = {
        hasSameDrivers: true,
        hasSameConnectors: true,
        hasSameAccount: true,
        alreadyLinked: true
      };
      this.devices.forEach(device => {
        if (device.deviceDriver.id !== get(this.devices[0], 'deviceDriver.id')) {
          result.hasSameDrivers = false;
        }
        if (device.properties.bridge.configId !== get(this.devices[0], 'properties.bridge.configId')) {
          result.hasSameConnectors = false;
        }
        if (device.tenantId !== get(this.devices[0], 'tenantId')) {
          result.hasSameAccount = false;
        }
        if (device.deviceTemplateId !== null) {
          result.alreadyLinked = false;
        }
      });
      const summary = Object.values(result).every(value => value === true);
      result.summary = summary;
      return result;
    },
    removeTagsContainsAddTags() {
      const tagsToRemoveContainsTagsToAdd = this.stepForm.tags.filter(tag => this.stepForm.tagsToRemove.includes(tag));
      return tagsToRemoveContainsTagsToAdd.length;
    },
    removeGroupsContainsAddGroups() {
      const groupsToRemoveContainsGroupsToAdd = this.stepForm.groupsTags.filter(group => this.stepForm.groupsToRemove.includes(group));
      return groupsToRemoveContainsGroupsToAdd.length;
    }
  },
  watch: {
    isOpen() {
      if (this.isOpen) {
        const scopes = this.devices.reduce((prev, acc) => {
          if (prev.indexOf(acc.tenantId) < 0) {
            prev.push(acc.tenantId);
          }
          return prev;
        }, []);
        this.tenantId = scopes[0];
      }
    },
    step() {
      if (this.step === 2 && this.stepForm.selectMode === this.modes.LINK_DEVICES_TO_A_TEMPLATE && this.linkSelectionToTemplateCheck.summary) {
        this.fetchTemplates();
      } else if (this.step === 2 && this.stepForm.selectMode === this.modes.DELETE_ALL_SELECTED_DEVICES) {
        this.hasDeviceThatReadFromExternalSystem = this.devices.some(d => !bridgesThatDoNotReadFromExternalData.includes(d.properties.bridge.type));
      }
    }
  },
  created() {
    this.fetchDeviceGroups();
  },
  methods: {
    get,
    async endTemplatesIntersect(entries, observer, isIntersecting) {
      if (isIntersecting) {
        await this.fetchTemplates();
      }
    },
    async fetchTemplates() {
      if (!this.linkSelectionToTemplateCheck.summary || !this.deviceTemplatesData.hasMore || this.deviceTemplatesData.isLoading || !this.devices.length) {
        return;
      }
      try {
        const TEMPLATE_PAGE_SIZE = 10;
        this.deviceTemplatesData.isLoading = true;
        const searchItems = [{
          variable: 'tenantId',
          search: get(this.devices[0], 'tenantId')
        }, {
          variable: 'connectorId',
          search: get(this.devices[0], 'properties.bridge.configId')
        }];
        const reqDeviceDriverId = get(this.devices[0], 'deviceDriver.id');
        if (reqDeviceDriverId) {
          searchItems.push({
            variable: 'deviceDriverId',
            search: reqDeviceDriverId
          });
        }
        const templates = await ApiService.deviceTemplatesFetch({
          pageSize: TEMPLATE_PAGE_SIZE,
          page: this.deviceTemplatesData.currentPage,
          tenantIds: [this.devices[0].tenantId],
          searchItems,
          searchOperator: 'AND'
        });
        this.deviceTemplatesData.currentPage++;
        const fetchedTemplates = templates.data.map(template => ({
          text: template.ProductiveVersion.title,
          id: template.id
        }));
        this.deviceTemplatesData.templates = [...this.deviceTemplatesData.templates, ...fetchedTemplates];
        if (this.deviceTemplatesData.templates.length >= templates.pagination['total-count']) {
          this.deviceTemplatesData.hasMore = false;
        }
      } catch (error) {
        console.error('Error fetching templates:', error);
        this.$snack(this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.snacks.fetchError'), 'error');
      } finally {
        this.deviceTemplatesData.isLoading = false;
      }
    },
    applyChanges() {
      bulkData.entities = this.devices.map(item => item.id);
      bulkData.title = this.stepForm.title;
      bulkData.tenantId = this.tenantId;
      if (this.stepForm.operationalStatus || this.stepForm.operationalStatus === 0) {
        bulkData.executions.operationalStatus = this.stepForm.operationalStatus;
      }
      if (this.stepForm.tags && this.stepForm.tags.length) {
        bulkData.executions.tags = this.stepForm.tags;
      }
      if (this.stepForm.groupsTags && this.stepForm.groupsTags.length) {
        bulkData.executions.groups = this.stepForm.groupsTags;
      }
      if (this.stepForm.tagsToRemove && this.stepForm.tagsToRemove.length) {
        bulkData.executions.tagsToRemove = this.stepForm.tagsToRemove;
      }
      if (this.stepForm.groupsToRemove && this.stepForm.groupsToRemove.length) {
        bulkData.executions.groupsToRemove = this.stepForm.groupsToRemove;
      }
      if (this.stepForm.parentId) {
        bulkData.executions.parentId = this.stepForm.parentId;
      }
      if (this.stepForm.deviceTemplates) {
        bulkData.executions.templateId = this.stepForm.deviceTemplates;
      }
      if (this.stepForm.selectMode === this.modes.DELETE_ALL_SELECTED_DEVICES) {
        bulkData.executions.deletionOfDevices = {
          deleteFromRemote: this.stepForm.removeFromExternalSystem
        };
        bulkData.title = `${bulkData.title} deletion`;
      }
      ApiService.createBackgroundRunnerBulkEdit(bulkData).then(() => {
        this.closeDialog();
        this.$snack(this.$i18n_t('DigitalTwin.VirtualDevice.bulkEditSuccess', {
          n: this.getTotalDevicesNumber
        }), 'success');
      }).catch(error => {
        this.closeDialog();
        this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
      });
    },
    closeDialog() {
      this.step = 1;
      this.stepForm = {
        selectMode: null,
        operationalStatus: null,
        title: '',
        parentId: null,
        groupsTags: [],
        tags: [],
        groupsToRemove: [],
        tagsToRemove: [],
        deviceTemplates: null,
        removeFromExternalSystem: false,
        numberOfVirtualDevices: ''
      };
      this.deviceTags.tags = [];
      this.deviceTemplatesData.isLoading = false;
      this.deviceTemplatesData.templates = [];
      this.deviceTemplatesData.currentPage = 1;
      this.deviceTemplatesData.hasMore = true;
      bulkData.executions = {};
      this.$emit('close');
    },
    parentSelectorFilter(item) {
      return (
        // only allow new parents from the same tenant
        item.tenantId === this.devices.map(item => item.tenantId)[0]
      );
    },
    setTags(tags) {
      this.stepForm.tags = tags;
    },
    setTagsToRemove(tags) {
      this.stepForm.tagsToRemove = tags;
    },
    fetchDeviceGroups() {
      ApiService.virtualDeviceFetchGroups().then(res => {
        this.deviceGroups = res.groupList || [];
      }).catch(error => {
        this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.errorFindingAccounts'), 'error');
        console.error(error);
      });
    },
    numberOfDevicesMatch() {
      if (this.stepForm.selectMode !== this.modes.DELETE_ALL_SELECTED_DEVICES) {
        return true;
      }
      return Number(this.stepForm.numberOfVirtualDevices) === this.getTotalDevicesNumber;
    }
  }
};